import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { utils } from '../utils.js';

const applyPeyote = (bead, i) => {
    if (settings.ignoreLastRow) {
        if (bead.column === settings.columns - 1) {
            if (!beads.rowOffset[bead.row]) {
                bead.ignore = true;
            }
        }
    }
};

const getStandardDimensions = (myRows, myColumns, diameter, beadLength) => {
    return {
        width: myColumns * diameter / 10,
        height: myRows * beadLength / 10
    };
};

const getPeyoteRowsAndColumns = ({rows, columns}) => {
    rows = Math.ceil(rows / 2);
    [rows, columns] = [columns, rows];
    return [rows, columns];
};

const getPeyoteDisplayRowsAndColumns = ({rows, columns}) => {
    const cols = settings.ignoreLastRow ? (columns * 2) - 1 : columns * 2;
    return [cols, rows];
};

const getPeyoteCoordinates = bead => {
    let row = bead.row, column = bead.column;

    let addRow = (beads.rowOffset[row]) ? 0 : 1;
    [row, column] = [column, settings.rows - row - 1];
    row = (row * 2) + addRow;
    return [row, column];
};

const applyOffset = ({fileOffset}) => {

    // load in offset pattern

    if (fileOffset) {
        fileOffset.forEach((num, i) => {
            beads.rowOffset[i] = num;
        });
    }
};

export const loomBrickPeyoteConfig = [
    {
        name: 'loom',
        displayName: 'Loom',
        colDist: () => 38,
        rowDist: () => utils.getConvertedbeadDisplayHeight() + 2,
        offset: () => -19,
        offsetPattern: [0],
        apply: null,
        commutes: false,
        plastic: false,
        canSelectCommute: true,
        canSelectDirection: true,
        canSelectStartingBead: true,
        canSelectPanelWidth: true,
        canExportSmallDiagrams: true,
        getDimensions: getStandardDimensions,
        newProject(config) {
            applyOffset({fileOffset: config.offset});
        },
        disabledTools: ['Star'],
        getRowsAndColumns({rows, columns}) {
            return [columns, rows];
        },
        getDisplayRowsAndColumns({rows, columns}) {
            return [columns, rows];
        },
        noOffsetInPaint: true,
        arrangeGrid: true
    },
    {
        name: 'brick',
        displayName: 'Brick',
        colDist: () => 38,
        rowDist: () => utils.getConvertedbeadDisplayHeight() + 2,
        offset: () => -19,
        offsetPattern: [0, 1],
        apply: null,
        commutes: true,
        canSelectCommute: true,
        canSelectDirection: false,
        canSelectStartingBead: true,
        canSelectPanelWidth: false,
        canExportSmallDiagrams: true,
        plastic: false,
        brickDrag: true,
        getDimensions: getStandardDimensions,
        newProject(config) {
            applyOffset({fileOffset: config.offset});
        },
        disabledTools: ['Star'],
        transform60: true,
        arrangeGrid: true
    },
    {
        name: 'brick-2',
        displayName: 'Brick 2 Drop',
        colDist: () => 38,
        rowDist: () => utils.getConvertedbeadDisplayHeight() + 2,
        offset: () => -19,
        offsetPattern: [0, 0, 1, 1],
        apply: null,
        commutes: true,
        canSelectCommute: true,
        canSelectDirection: false,
        canSelectStartingBead: true,
        canSelectPanelWidth: false,
        canExportSmallDiagrams: true,
        plastic: false,
        getDimensions: getStandardDimensions,
        newProject(config) {
            applyOffset({fileOffset: config.offset});
        },
        disabledTools: ['Star'],
        arrangeGrid: true
    },
    {
        name: 'brick-3',
        displayName: 'Brick 3 Drop',
        colDist: () => 38,
        rowDist: () => utils.getConvertedbeadDisplayHeight() + 2,
        offset: () => -19,
        offsetPattern: [0, 0, 0, 1, 1, 1],
        apply: null,
        commutes: true,
        canSelectCommute: true,
        canSelectDirection: false,
        canSelectStartingBead: true,
        canSelectPanelWidth: false,
        canExportSmallDiagrams: true,
        plastic: false,
        getDimensions: getStandardDimensions,
        newProject(config) {
            applyOffset({fileOffset: config.offset});
        },
        disabledTools: ['Star'],
        arrangeGrid: true
    },
    {
        name: 'peyote',
        displayName: 'Peyote',
        colDist: () => 38,
        rowDist: () => utils.getConvertedbeadDisplayHeight() + 2,
        offset: () => -19,
        offsetPattern: [0, 1],
        apply: () => {
            beads.arr.forEach((bead, i) => applyPeyote(bead, i));
        },
        rotateCamera: true,
        commutes: true,
        canSelectCommute: true,
        canSelectDirection: false,
        canSelectStartingBead: true,
        canSelectPanelWidth: true,
        canExportSmallDiagrams: true,
        plastic: false,
        brickDrag: true,
        getDimensions: getStandardDimensions,
        newProject(config) {
            applyOffset({fileOffset: config.offset});
        },
        disabledTools: ['Star'],
        getRowsAndColumns: getPeyoteRowsAndColumns,
        getDisplayRowsAndColumns: getPeyoteDisplayRowsAndColumns,
        getCoordinates: getPeyoteCoordinates,
        transform60: true,
        arrangeGrid: true
    },
    {
        name: 'peyote-2',
        displayName: 'Peyote 2 Drop',
        colDist: () => 38,
        rowDist: () => utils.getConvertedbeadDisplayHeight() + 2,
        offset: () => -19,
        offsetPattern: [0, 0, 1, 1],
        apply: () => {
            beads.arr.forEach((bead, i) => applyPeyote(bead, i));
        },
        rotateCamera: true,
        commutes: true,
        canSelectCommute: true,
        canSelectDirection: false,
        canSelectStartingBead: true,
        canSelectPanelWidth: true,
        canExportSmallDiagrams: true,
        plastic: false,
        getDimensions: getStandardDimensions,
        newProject(config) {
            applyOffset({fileOffset: config.offset});
        },
        disabledTools: ['Star'],
        getRowsAndColumns: getPeyoteRowsAndColumns,
        getDisplayRowsAndColumns: getPeyoteDisplayRowsAndColumns,
        getCoordinates: getPeyoteCoordinates,
        arrangeGrid: true
    },
    {
        name: 'peyote-3',
        displayName: 'Peyote 3 Drop',
        colDist: () => 38,
        rowDist: () => utils.getConvertedbeadDisplayHeight() + 2,
        offset: () => -19,
        offsetPattern: [0, 0, 0, 1, 1, 1],
        apply: () => {
            beads.arr.forEach((bead, i) => applyPeyote(bead, i));
        },
        rotateCamera: true,
        commutes: true,
        canSelectCommute: true,
        canSelectDirection: false,
        canSelectStartingBead: true,
        canSelectPanelWidth: true,
        canExportSmallDiagrams: true,
        plastic: false,
        getDimensions: getStandardDimensions,
        newProject(config) {
            applyOffset({fileOffset: config.offset});
        },
        disabledTools: ['Star'],
        getRowsAndColumns: getPeyoteRowsAndColumns,
        getDisplayRowsAndColumns: getPeyoteDisplayRowsAndColumns,
        getCoordinates: getPeyoteCoordinates,
        arrangeGrid: true
    },
    {
        name: 'herringbone',
        displayName: 'Herringbone',
        colDist: () => 40,
        rowDist: () => utils.getConvertedbeadDisplayHeight() + 4,
        offset: () => 0,
        offsetPattern: [0],
        apply: () => {
            beads.arr.forEach(bead => bead.setAngle(bead.column % 2 === 0 ? 8 : -8));
        },
        commutes: true,
        canSelectCommute: true,
        canSelectDirection: false,
        beadingDirection: 'horizontal',
        canSelectStartingBead: true,
        canSelectPanelWidth: false,
        canExportSmallDiagrams: true,
        plastic: false,
        getDimensions: (myRows, myColumns, diameter, beadLength) => {
            return {
                width: (myColumns * diameter / 10) * 1.05,
                height: (myRows * beadLength / 10) * 1.085
            };
        },
        disabledTools: ['Star', 'Row Shift'],
        noOffsetInPaint: true,
        arrangeGrid: true
    },
];